import React, { useState } from 'react';

// "Add your mobile number" — a small strip under the app header for an account with no verified
// mobile, while SMS verification is available (docs/SIGNUP.md). Dismissal is stored per user in the
// DB (PUT /api/prefs; /api/auth/me reads it back as phoneReminderDismissed), not in the browser.
export const REMINDER_PREF = 'phx.reminder.mobileDismissed';

export function showMobileReminder(user, active) {
  return !!(user && user.smsAvailable && !user.phoneVerified && !user.phoneRequired
    && !user.phoneReminderDismissed && active !== 'My Profile');
}

export default function MobileReminder({ user, active }) {
  const [hidden, setHidden] = useState(false);
  if (hidden || !showMobileReminder(user, active)) return null;
  const dismiss = () => {
    setHidden(true);
    fetch('/api/prefs', {
      method: 'PUT', credentials: 'include', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ key: REMINDER_PREF, value: '1' }),
    }).catch(() => { /* shows again next visit; nothing lost */ });
  };
  return (
    <div role="note" style={{
      display: 'flex', alignItems: 'center', gap: 12, padding: '10px 24px', fontSize: 14,
      background: 'color-mix(in oklab, var(--accent) 10%, var(--surface))', borderBottom: '1px solid var(--border)',
    }}>
      <span>Add your mobile number. <a href="/my-profile" style={{ color: 'var(--link, var(--accent))', fontWeight: 650 }}>Add it on My Profile</a></span>
      <button type="button" aria-label="Dismiss" onClick={dismiss} style={{
        marginLeft: 'auto', background: 'none', border: 'none', color: 'var(--muted)', fontSize: 18, cursor: 'pointer', lineHeight: 1,
      }}>×</button>
    </div>
  );
}
